import React, { useRef, useState } from 'react';
import { motion } from 'framer-motion';

// Small "magnetic" wrapper: the element gently follows the cursor within
// its bounds, then springs back on leave. Cheap way to make a CTA feel alive.
const MagneticButton = ({ children, className = '', as = 'a', ...props }) => {
  const ref = useRef(null);
  const [offset, setOffset] = useState({ x: 0, y: 0 });

  const handleMouseMove = (e) => {
    const rect = ref.current?.getBoundingClientRect();
    if (!rect) return;
    const x = e.clientX - rect.left - rect.width / 2;
    const y = e.clientY - rect.top - rect.height / 2;
    setOffset({ x: x * 0.25, y: y * 0.25 });
  };

  const handleMouseLeave = () => setOffset({ x: 0, y: 0 });

  const Component = motion[as] || motion.a;

  return (
    <Component
      ref={ref}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      animate={{ x: offset.x, y: offset.y }}
      transition={{ type: 'spring', stiffness: 200, damping: 15, mass: 0.4 }}
      className={className}
      {...props}
    >
      {children}
    </Component>
  );
};

export default MagneticButton;
